export const state = () => ({
  isSaved: true,
});

export const mutations = {
  changeSaved(state, value) {
    state.isSaved = value;
  },
};

export const actions = {
  changeSaved({ commit }, value) {
    commit('changeSaved', value);
  },
};

export default { namespaced: true, state, mutations, actions };
